module.exports = function getResource(label, vars = []) {
    let resources = {
        shipInternationalText: 'Ship international',
        canadaCheckoutText: 'Canada checkout',
        unitedStatesCheckoutText: 'United States checkout',
        shippingToText: 'Shipping to',
        changeCountryText: 'Change country'
    };

    return resources[label];
};
